// extracted by mini-css-extract-plugin
export var layoutContainer = "_57-0";
export var layoutContainerNoRounding = "_57-6";
export var layoutContainerOpen = "_57-5";
export var layoutContainerResizing = "_57-1";
export var mainContent = "_57-2";
export var resizeDivider = "_57-3";
export var slidePanel = "_57-4";